module.exports = __webpack_public_path__ + "static/media/LoginImage.64443b73.jpg";